import {
  END_LOADING,
  CREATE_MANUFACTURING_BOM,
  DELETE_MANUFACTURING_BOM,
  EXPLODE_MANUFACTURING_BOM,
  CREATE_MANUFACTURING_ROUTING,
  CREATE_MANUFACTURING_WORK_ORDER,
  CREATE_MANUFACTURING_WORK_CENTER,
  FETCH_MANUFACTURING_ROUTINGS,
  FETCH_MANUFACTURING_BOM,
  FETCH_MANUFACTURING_BOMS,
  FETCH_MANUFACTURING_PRESETS,
  FETCH_MANUFACTURING_READINESS,
  FETCH_MANUFACTURING_SETTINGS,
  FETCH_MANUFACTURING_WORK_ORDER,
  FETCH_MANUFACTURING_WORK_ORDER_COST,
  FETCH_MANUFACTURING_WORK_ORDERS,
  GENERATE_MANUFACTURING_WORK_ORDER_LOT_SERIAL_QR_LABELS,
  GENERATE_MANUFACTURING_WORK_ORDER_QR_LABEL,
  FETCH_MANUFACTURING_WORK_CENTER_CAPACITY,
  FETCH_MANUFACTURING_WORK_CENTERS,
  FETCH_MANUFACTURING_QC_INSPECTION,
  FETCH_MANUFACTURING_QC_INSPECTIONS,
  FETCH_MANUFACTURING_QC_CERTIFICATE_OF_ANALYSIS,
  FETCH_MANUFACTURING_QC_CAPAS,
  FETCH_MANUFACTURING_QC_NON_CONFORMANCES,
  FETCH_MANUFACTURING_QC_TEMPLATE,
  FETCH_MANUFACTURING_QC_TEMPLATES,
  FETCH_MANUFACTURING_PRODUCTION_PLAN,
  FETCH_MANUFACTURING_PRODUCTION_PLAN_CAPACITY,
  FETCH_MANUFACTURING_PRODUCTION_MRP_RUN,
  FETCH_MANUFACTURING_PRODUCTION_PLAN_SHORTAGES,
  FETCH_MANUFACTURING_PRODUCTION_PLANS,
  FETCH_MANUFACTURING_SUBCONTRACT_ORDER,
  FETCH_MANUFACTURING_SUBCONTRACT_ORDERS,
  FETCH_MANUFACTURING_MAINTENANCE_REQUEST,
  FETCH_MANUFACTURING_MAINTENANCE_REQUESTS,
  FETCH_MANUFACTURING_WORK_CENTER_OEE,
  FETCH_MANUFACTURING_DASHBOARD_REPORT,
  FETCH_MANUFACTURING_PRODUCTION_SUMMARY_REPORT,
  FETCH_MANUFACTURING_WORK_CENTER_UTILIZATION_REPORT,
  FETCH_MANUFACTURING_MAINTENANCE_LOG_REPORT,
  FETCH_MANUFACTURING_MATERIAL_CONSUMPTION_REPORT,
  FETCH_MANUFACTURING_COST_VARIANCE_REPORT,
  FETCH_MANUFACTURING_SCRAP_YIELD_REPORT,
  FETCH_MANUFACTURING_QC_SUMMARY_REPORT,
  FETCH_MANUFACTURING_SUBCONTRACTING_STATUS_REPORT,
  FETCH_MANUFACTURING_WIP_AGING_REPORT,
  FETCH_MANUFACTURING_LOT_SERIAL_GENEALOGY_REPORT,
  FETCH_MANUFACTURING_SUBLEDGER_RECONCILIATION_REPORT,
  FETCH_MANUFACTURING_CONTROL_EXCEPTIONS_REPORT,
  GENERATE_MANUFACTURING_PREVENTIVE_MAINTENANCE,
  MANUFACTURING_ERROR,
  ROLLUP_MANUFACTURING_BOM_COST,
  START_LOADING,
  CREATE_MANUFACTURING_QC_INSPECTION,
  CREATE_MANUFACTURING_QC_NON_CONFORMANCE,
  CREATE_MANUFACTURING_QC_TEMPLATE,
  CREATE_MANUFACTURING_PRODUCTION_PLAN,
  CREATE_MANUFACTURING_SUBCONTRACT_ORDER,
  CREATE_MANUFACTURING_MAINTENANCE_REQUEST,
  UPDATE_MANUFACTURING_PRODUCTION_PLAN,
  UPDATE_MANUFACTURING_QC_INSPECTION,
  UPDATE_MANUFACTURING_QC_CAPA,
  UPDATE_MANUFACTURING_QC_NON_CONFORMANCE,
  UPDATE_MANUFACTURING_QC_TEMPLATE,
  UPDATE_MANUFACTURING_SUBCONTRACT_ORDER,
  UPDATE_MANUFACTURING_MAINTENANCE_REQUEST,
  UPDATE_MANUFACTURING_ROUTING,
  UPDATE_MANUFACTURING_SETTINGS,
  UPDATE_MANUFACTURING_BOM,
  UPDATE_MANUFACTURING_WORK_ORDER,
  UPDATE_MANUFACTURING_WORK_CENTER,
} from "../actions/constants";

const initialState = {
  settings: null,
  presets: {},
  readiness: null,
  boms: [],
  bomPagination: { total: 0, page: 1, pageSize: 200 },
  currentBom: null,
  bomExplosion: null,
  bomCostRollup: null,
  workCenters: [],
  workCenterPagination: { total: 0, page: 1, pageSize: 200 },
  workCenterCapacity: null,
  routings: [],
  routingPagination: { total: 0, page: 1, pageSize: 200 },
  workOrders: [],
  workOrderPagination: { total: 0, page: 1, pageSize: 200 },
  currentWorkOrder: null,
  currentWorkOrderCost: null,
  currentWorkOrderQrLabel: null,
  currentWorkOrderLotSerialQrLabels: null,
  qcTemplates: [],
  qcTemplatePagination: { total: 0, page: 1, pageSize: 200 },
  currentQcTemplate: null,
  qcInspections: [],
  qcInspectionPagination: { total: 0, page: 1, pageSize: 200 },
  currentQcInspection: null,
  currentQcCertificateOfAnalysis: null,
  qcNonConformances: [],
  qcNonConformancePagination: { total: 0, page: 1, pageSize: 100 },
  qcCapas: [],
  qcCapaPagination: { total: 0, page: 1, pageSize: 100 },
  productionPlans: [],
  productionPlanPagination: { total: 0, page: 1, pageSize: 200 },
  currentProductionPlan: null,
  productionPlanShortages: null,
  productionPlanCapacity: null,
  productionMrpRun: null,
  subcontractOrders: [],
  subcontractOrderPagination: { total: 0, page: 1, pageSize: 200 },
  currentSubcontractOrder: null,
  maintenanceRequests: [],
  maintenanceRequestPagination: { total: 0, page: 1, pageSize: 200 },
  currentMaintenanceRequest: null,
  workCenterOee: null,
  preventiveMaintenanceResult: null,
  dashboardReport: null,
  productionSummaryReport: null,
  workCenterUtilizationReport: null,
  maintenanceLogReport: null,
  materialConsumptionReport: null,
  costVarianceReport: null,
  scrapYieldReport: null,
  qcSummaryReport: null,
  subcontractingStatusReport: null,
  wipAgingReport: null,
  lotSerialGenealogyReport: null,
  subledgerReconciliationReport: null,
  controlExceptionsReport: null,
  isLoading: false,
  error: null,
};

const manufacturingReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_MANUFACTURING_SETTINGS:
    case UPDATE_MANUFACTURING_SETTINGS:
      return { ...state, settings: action.payload, error: null };
    case FETCH_MANUFACTURING_PRESETS:
      return { ...state, presets: action.payload || {}, error: null };
    case FETCH_MANUFACTURING_READINESS:
      return { ...state, readiness: action.payload, error: null };
    case FETCH_MANUFACTURING_BOMS:
      return {
        ...state,
        boms: action.payload?.data || [],
        bomPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_BOM:
      return { ...state, currentBom: action.payload, error: null };
    case CREATE_MANUFACTURING_BOM:
      return { ...state, boms: [action.payload, ...state.boms], currentBom: action.payload, error: null };
    case UPDATE_MANUFACTURING_BOM:
      return {
        ...state,
        boms: state.boms.map((bom) => (bom._id === action.payload?._id ? action.payload : bom)),
        currentBom: state.currentBom?._id === action.payload?._id ? action.payload : state.currentBom,
        error: null,
      };
    case DELETE_MANUFACTURING_BOM:
      return {
        ...state,
        boms: state.boms.filter((bom) => bom._id !== action.payload),
        currentBom: state.currentBom?._id === action.payload ? null : state.currentBom,
        error: null,
      };
    case EXPLODE_MANUFACTURING_BOM:
      return { ...state, bomExplosion: action.payload, error: null };
    case ROLLUP_MANUFACTURING_BOM_COST:
      return { ...state, bomCostRollup: action.payload, error: null };
    case FETCH_MANUFACTURING_WORK_CENTERS:
      return {
        ...state,
        workCenters: action.payload?.data || [],
        workCenterPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case CREATE_MANUFACTURING_WORK_CENTER:
      return { ...state, workCenters: [action.payload, ...state.workCenters], error: null };
    case UPDATE_MANUFACTURING_WORK_CENTER:
      return {
        ...state,
        workCenters: state.workCenters.map((workCenter) =>
          workCenter._id === action.payload?._id ? action.payload : workCenter,
        ),
        error: null,
      };
    case FETCH_MANUFACTURING_WORK_CENTER_CAPACITY:
      return { ...state, workCenterCapacity: action.payload, error: null };
    case FETCH_MANUFACTURING_ROUTINGS:
      return {
        ...state,
        routings: action.payload?.data || [],
        routingPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case CREATE_MANUFACTURING_ROUTING:
      return { ...state, routings: [action.payload, ...state.routings], error: null };
    case UPDATE_MANUFACTURING_ROUTING:
      return {
        ...state,
        routings: state.routings.map((routing) =>
          routing._id === action.payload?._id ? action.payload : routing,
        ),
        error: null,
      };
    case FETCH_MANUFACTURING_WORK_ORDERS:
      return {
        ...state,
        workOrders: action.payload?.data || [],
        workOrderPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_WORK_ORDER:
      return { ...state, currentWorkOrder: action.payload, error: null };
    case FETCH_MANUFACTURING_WORK_ORDER_COST:
      return { ...state, currentWorkOrderCost: action.payload, error: null };
    case CREATE_MANUFACTURING_WORK_ORDER:
      return {
        ...state,
        workOrders: [action.payload, ...state.workOrders],
        currentWorkOrder: action.payload,
        error: null,
      };
    case UPDATE_MANUFACTURING_WORK_ORDER:
      return {
        ...state,
        workOrders: state.workOrders.map((workOrder) =>
          workOrder._id === action.payload?._id ? action.payload : workOrder,
        ),
        currentWorkOrder:
          state.currentWorkOrder?._id === action.payload?._id ? action.payload : state.currentWorkOrder,
        error: null,
      };
    case GENERATE_MANUFACTURING_WORK_ORDER_QR_LABEL:
    case GENERATE_MANUFACTURING_WORK_ORDER_LOT_SERIAL_QR_LABELS:
      return {
        ...state,
        ...(action.type === GENERATE_MANUFACTURING_WORK_ORDER_QR_LABEL
          ? { currentWorkOrderQrLabel: action.payload }
          : { currentWorkOrderLotSerialQrLabels: action.payload }),
        workOrders: state.workOrders.map((workOrder) =>
          workOrder._id === action.payload?.workOrder?._id ? action.payload.workOrder : workOrder,
        ),
        currentWorkOrder:
          state.currentWorkOrder?._id === action.payload?.workOrder?._id
            ? action.payload.workOrder
            : state.currentWorkOrder,
        error: null,
      };
    case FETCH_MANUFACTURING_QC_TEMPLATES:
      return {
        ...state,
        qcTemplates: action.payload?.data || [],
        qcTemplatePagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_QC_TEMPLATE:
      return { ...state, currentQcTemplate: action.payload, error: null };
    case CREATE_MANUFACTURING_QC_TEMPLATE:
      return {
        ...state,
        qcTemplates: [action.payload, ...state.qcTemplates],
        currentQcTemplate: action.payload,
        error: null,
      };
    case UPDATE_MANUFACTURING_QC_TEMPLATE:
      return {
        ...state,
        qcTemplates: state.qcTemplates.map((template) =>
          template._id === action.payload?._id ? action.payload : template,
        ),
        currentQcTemplate:
          state.currentQcTemplate?._id === action.payload?._id ? action.payload : state.currentQcTemplate,
        error: null,
      };
    case FETCH_MANUFACTURING_QC_INSPECTIONS:
      return {
        ...state,
        qcInspections: action.payload?.data || [],
        qcInspectionPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_QC_INSPECTION:
      return { ...state, currentQcInspection: action.payload, error: null };
    case FETCH_MANUFACTURING_QC_CERTIFICATE_OF_ANALYSIS:
      return { ...state, currentQcCertificateOfAnalysis: action.payload, error: null };
    case FETCH_MANUFACTURING_QC_NON_CONFORMANCES:
      return {
        ...state,
        qcNonConformances: action.payload?.data || [],
        qcNonConformancePagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 100,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_QC_CAPAS:
      return {
        ...state,
        qcCapas: action.payload?.data || [],
        qcCapaPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 100,
        },
        error: null,
      };
    case CREATE_MANUFACTURING_QC_INSPECTION:
      return {
        ...state,
        qcInspections: [action.payload, ...state.qcInspections],
        currentQcInspection: action.payload,
        error: null,
      };
    case UPDATE_MANUFACTURING_QC_INSPECTION:
      return {
        ...state,
        qcInspections: state.qcInspections.map((inspection) =>
          inspection._id === action.payload?._id ? action.payload : inspection,
        ),
        currentQcInspection:
          state.currentQcInspection?._id === action.payload?._id ? action.payload : state.currentQcInspection,
        error: null,
      };
    case CREATE_MANUFACTURING_QC_NON_CONFORMANCE: {
      const ncr = action.payload?.nonConformance || action.payload;
      return {
        ...state,
        qcNonConformances: ncr?._id ? [ncr, ...state.qcNonConformances] : state.qcNonConformances,
        error: null,
      };
    }
    case UPDATE_MANUFACTURING_QC_NON_CONFORMANCE: {
      const ncr = action.payload?.nonConformance || action.payload;
      return {
        ...state,
        qcNonConformances: state.qcNonConformances.map((row) =>
          row._id === ncr?._id ? ncr : row,
        ),
        error: null,
      };
    }
    case UPDATE_MANUFACTURING_QC_CAPA:
      return {
        ...state,
        qcCapas: state.qcCapas.map((capa) =>
          capa._id === action.payload?._id ? action.payload : capa,
        ),
        error: null,
      };
    case FETCH_MANUFACTURING_PRODUCTION_PLANS:
      return {
        ...state,
        productionPlans: action.payload?.data || [],
        productionPlanPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_PRODUCTION_PLAN:
      return { ...state, currentProductionPlan: action.payload, error: null };
    case CREATE_MANUFACTURING_PRODUCTION_PLAN:
      return {
        ...state,
        productionPlans: [action.payload, ...state.productionPlans],
        currentProductionPlan: action.payload,
        error: null,
      };
    case UPDATE_MANUFACTURING_PRODUCTION_PLAN:
      return {
        ...state,
        productionPlans: state.productionPlans.map((plan) =>
          plan._id === action.payload?._id ? action.payload : plan,
        ),
        currentProductionPlan:
          state.currentProductionPlan?._id === action.payload?._id ? action.payload : state.currentProductionPlan,
        error: null,
      };
    case FETCH_MANUFACTURING_PRODUCTION_PLAN_SHORTAGES:
      return { ...state, productionPlanShortages: action.payload, error: null };
    case FETCH_MANUFACTURING_PRODUCTION_PLAN_CAPACITY:
      return { ...state, productionPlanCapacity: action.payload, error: null };
    case FETCH_MANUFACTURING_PRODUCTION_MRP_RUN:
      return { ...state, productionMrpRun: action.payload, error: null };
    case FETCH_MANUFACTURING_SUBCONTRACT_ORDERS:
      return {
        ...state,
        subcontractOrders: action.payload?.data || [],
        subcontractOrderPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_SUBCONTRACT_ORDER:
      return { ...state, currentSubcontractOrder: action.payload, error: null };
    case CREATE_MANUFACTURING_SUBCONTRACT_ORDER:
      return {
        ...state,
        subcontractOrders: [action.payload, ...state.subcontractOrders],
        currentSubcontractOrder: action.payload,
        error: null,
      };
    case UPDATE_MANUFACTURING_SUBCONTRACT_ORDER:
      return {
        ...state,
        subcontractOrders: state.subcontractOrders.map((order) =>
          order._id === action.payload?._id ? action.payload : order,
        ),
        currentSubcontractOrder:
          state.currentSubcontractOrder?._id === action.payload?._id
            ? action.payload
            : state.currentSubcontractOrder,
        error: null,
      };
    case FETCH_MANUFACTURING_MAINTENANCE_REQUESTS:
      return {
        ...state,
        maintenanceRequests: action.payload?.data || [],
        maintenanceRequestPagination: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 200,
        },
        error: null,
      };
    case FETCH_MANUFACTURING_MAINTENANCE_REQUEST:
      return { ...state, currentMaintenanceRequest: action.payload, error: null };
    case CREATE_MANUFACTURING_MAINTENANCE_REQUEST:
      return {
        ...state,
        maintenanceRequests: [action.payload, ...state.maintenanceRequests],
        currentMaintenanceRequest: action.payload,
        error: null,
      };
    case UPDATE_MANUFACTURING_MAINTENANCE_REQUEST:
      return {
        ...state,
        maintenanceRequests: state.maintenanceRequests.map((request) =>
          request._id === action.payload?._id ? action.payload : request,
        ),
        currentMaintenanceRequest:
          state.currentMaintenanceRequest?._id === action.payload?._id
            ? action.payload
            : state.currentMaintenanceRequest,
        error: null,
      };
    case FETCH_MANUFACTURING_WORK_CENTER_OEE:
      return { ...state, workCenterOee: action.payload, error: null };
    case GENERATE_MANUFACTURING_PREVENTIVE_MAINTENANCE:
      return {
        ...state,
        preventiveMaintenanceResult: action.payload,
        maintenanceRequests: [
          ...(action.payload?.created || []),
          ...state.maintenanceRequests,
        ],
        error: null,
      };
    case FETCH_MANUFACTURING_DASHBOARD_REPORT:
      return { ...state, dashboardReport: action.payload, error: null };
    case FETCH_MANUFACTURING_PRODUCTION_SUMMARY_REPORT:
      return { ...state, productionSummaryReport: action.payload, error: null };
    case FETCH_MANUFACTURING_WORK_CENTER_UTILIZATION_REPORT:
      return { ...state, workCenterUtilizationReport: action.payload, error: null };
    case FETCH_MANUFACTURING_MAINTENANCE_LOG_REPORT:
      return { ...state, maintenanceLogReport: action.payload, error: null };
    case FETCH_MANUFACTURING_MATERIAL_CONSUMPTION_REPORT:
      return { ...state, materialConsumptionReport: action.payload, error: null };
    case FETCH_MANUFACTURING_COST_VARIANCE_REPORT:
      return { ...state, costVarianceReport: action.payload, error: null };
    case FETCH_MANUFACTURING_SCRAP_YIELD_REPORT:
      return { ...state, scrapYieldReport: action.payload, error: null };
    case FETCH_MANUFACTURING_QC_SUMMARY_REPORT:
      return { ...state, qcSummaryReport: action.payload, error: null };
    case FETCH_MANUFACTURING_SUBCONTRACTING_STATUS_REPORT:
      return { ...state, subcontractingStatusReport: action.payload, error: null };
    case FETCH_MANUFACTURING_WIP_AGING_REPORT:
      return { ...state, wipAgingReport: action.payload, error: null };
    case FETCH_MANUFACTURING_LOT_SERIAL_GENEALOGY_REPORT:
      return { ...state, lotSerialGenealogyReport: action.payload, error: null };
    case FETCH_MANUFACTURING_SUBLEDGER_RECONCILIATION_REPORT:
      return { ...state, subledgerReconciliationReport: action.payload, error: null };
    case FETCH_MANUFACTURING_CONTROL_EXCEPTIONS_REPORT:
      return { ...state, controlExceptionsReport: action.payload, error: null };
    case MANUFACTURING_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default manufacturingReducer;
